export default "/fonts/vendor/mdui/dist/roboto/Roboto-Bold.woff?8bd7856b64b4313341ebfbc0136c9d74";